import { useCallback, useEffect } from 'react'

import {
  JingleCollectionGate,
  jingleCollectionByIdQuery,
} from '@/entities/jingle-collections'
import { ROUTES } from '@/shared/config'
import {
  ContentWrapper,
  ErrorResult,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { JingleCollectionForm } from '@/widgets/JingleCollectionForm'
import { JingleForm } from '@/widgets/JingleForm'
import {
  jingleFormModalClosed,
  jingleFormModalOpened,
} from '@/widgets/JingleForm'
import { Breadcrumb, Layout } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useParams } from 'react-router-dom'

export const JingleCollectionEditPage = () => {
  const { id } = useParams<{ id: string }>()
  const jingleCollection = useUnit(jingleCollectionByIdQuery)

  const openJingleFormModal = useUnit(jingleFormModalOpened)
  const closeJingleFormModal = useUnit(jingleFormModalClosed)
  const onJingleEditButtonClick = useCallback(
    (id: string) => {
      void openJingleFormModal({ id })
    },
    [openJingleFormModal],
  )

  useEffect(() => {
    return () => closeJingleFormModal()
  }, [closeJingleFormModal])

  return (
    <Layout>
      <JingleForm isModal />
      {id && <JingleCollectionGate id={id} />}
      <HidingSpin
        spinning={
          jingleCollection.pending ||
          (!jingleCollection.data && !jingleCollection.error)
        }
      >
        {jingleCollection.data && !jingleCollection.error ? (
          <>
            <HeaderContent
              breadcrumbSlot={
                <Breadcrumb
                  items={[
                    { title: 'Джинглы' },
                    {
                      title: (
                        <Link to={ROUTES.JINGLES.COLLECTIONS}>Подборки</Link>
                      ),
                    },
                    {
                      title: jingleCollection.data.name,
                    },
                  ]}
                />
              }
              title={jingleCollection.data.name}
              description="Раздел позволяет редактировать подборку джинглов"
            />

            <ContentWrapper>
              <JingleCollectionForm
                onJingleEditButtonClick={onJingleEditButtonClick}
              />
            </ContentWrapper>
          </>
        ) : (
          <ContentWrapper>
            <ErrorResult
              error={jingleCollection.error}
              notFoundConfig={{
                subTitle: 'Данной подборки не существует.',
                navigateTo: ROUTES.JINGLES.COLLECTIONS,
              }}
            />
          </ContentWrapper>
        )}
      </HidingSpin>
    </Layout>
  )
}
